"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DEFAULT_ICONS_PROPS = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUnifiedicons = _interopRequireWildcard(require("@bit/gerenciatd.unifiedicons.svg-icon-label"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUnifiedcomponents2 = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.button"));

var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.info-list"));

var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));

var _gerenciatdUnifiedcomponents4 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.card"));

require("./productSuggest.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const DEFAULT_ICONS_PROPS = {
  iconSize: 36,
  color: 'grey',
  viewBox: '0 0 200 200',
  labelPosition: 'left',
  kind: 'S'
};
exports.DEFAULT_ICONS_PROPS = DEFAULT_ICONS_PROPS;

class ProductSuggest extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "chooseLinkForThose", (optionsSelected, logged) => {
      const {
        options
      } = this.state;
      const {
        items
      } = options;
      let finalLink = null;
      const numberOfSelected = optionsSelected.length;

      if (numberOfSelected === 1) {
        const currentId = optionsSelected[0].id;
        finalLink = items.find(item => item.id === currentId);
      }
      /* Analise rest of combinations */


      if (numberOfSelected === 2) {
        const {
          combinations
        } = options;
        const ocurrence = combinations.filter(combo => {
          return combo.id1 === optionsSelected[0].id && combo.id2 === optionsSelected[1].id || combo.id1 === optionsSelected[1].id && combo.id2 === optionsSelected[0].id;
        });
        finalLink = ocurrence && ocurrence[0] && ocurrence[0] ? ocurrence[0] : null;
      }

      if (numberOfSelected === 3) {
        const {
          combinations
        } = options;
        const allCombo = combinations.find(combo => {
          return combo && combo.id3;
        });
        finalLink = allCombo && allCombo ? allCombo : null;
      }

      if (finalLink) {
        return logged ? finalLink.loggedLink : finalLink.link;
      }

      return null;
    });

    _defineProperty(this, "setOptionSelected", idSelected => {
      const {
        optionsSelected,
        logged
      } = this.state;
      const newOptionsSelected = optionsSelected || [];
      const id = optionsSelected ? optionsSelected.findIndex(item => item.id === idSelected) : -1;

      if (id < 0) {
        newOptionsSelected.push({
          id: idSelected
        });
      } else {
        newOptionsSelected.splice(id, 1);
      }

      const link = this.chooseLinkForThose(newOptionsSelected, logged);
      this.setState({
        optionsSelected: newOptionsSelected,
        linkCreated: link
      });
    });

    const {
      logged: _logged
    } = props;
    const _options = props;
    this.state = {
      options: _options,
      optionsSelected: [],
      linkCreated: null,
      logged: _logged
    };
  }

  render() {
    const {
      linkCreated,
      options,
      optionsSelected
    } = this.state;
    const {
      components,
      button
    } = options;
    const {
      defaultIconProps,
      SvgIconLoader
    } = this.props;
    let buttonDisable = true;

    if (linkCreated) {
      buttonDisable = false;
    }

    if (components) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "productSuggest",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "container",
          children: [components && components['TextInfo-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({}, components['TextInfo-1'])), components && components['TextInfo-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({}, components['TextInfo-2'])), components && components['InfoList-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "container list",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, _objectSpread({}, components['InfoList-1']))
          }), components && components['Button-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "cta",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread({}, components['Button-2']))
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "container flex",
            children: options.items && options.items.map((itemOption, index) => {
              let {
                svgIcon
              } = itemOption;
              svgIcon = _objectSpread(_objectSpread({}, defaultIconProps), svgIcon);
              const {
                label,
                id,
                taggingInfo
              } = itemOption;
              const isSelected = optionsSelected && optionsSelected.find(item => item.id === itemOption.id);
              let isCardSelected = false;

              if (isSelected) {
                svgIcon = _objectSpread(_objectSpread({}, svgIcon), {}, {
                  id: 'Ok',
                  kind: 'S',
                  iconColor: _gerenciatdUnifiedicons.SVG_ICON_COLOR.WHITE
                });
                isCardSelected = true;
              }

              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents4.default, {
                borderColor: itemOption.borderColor,
                bandTitleColor: itemOption.bandTitleColor,
                className: "itemProductSuggets",
                onClick: () => this.setOptionSelected(`${id}`),
                taggingInfo: taggingInfo,
                selected: isCardSelected,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, _objectSpread(_objectSpread({}, svgIcon), {}, {
                    label: label,
                    SvgIconLoader: SvgIconLoader
                  }))
                }, `product-suggest-${itemOption.id}`)
              }, `${itemOption.id}-${Date.now()}--${index.toString()}`);
            })
          }), options.items && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "container confirm",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
              label: button.label,
              color: button.color,
              className: buttonDisable ? 'selectbutton disable' : 'selectbutton enable',
              link: linkCreated || 'movistar.es',
              disable: buttonDisable,
              size: {
                w: _gerenciatdUnifiedcomponents2.BUTTON_WIDTH.MEDIUM
              },
              taggingInfo: button.taggingInfo
            })
          })]
        })
      });
    } else {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {});
    }
  }

}

ProductSuggest.WaitingComponent = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
  className: "configFake",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLoadingSkeleton.default, {
    count: 1,
    height: 30,
    width: "50%"
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "container",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLoadingSkeleton.default, {
      count: 1,
      height: 100,
      width: 200
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLoadingSkeleton.default, {
      count: 1,
      height: 100,
      width: 200
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLoadingSkeleton.default, {
      count: 1,
      height: 100,
      width: 200
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLoadingSkeleton.default, {
    count: 1,
    height: 40,
    width: 240
  })]
});

ProductSuggest.defaultProps = {
  logged: false,
  defaultIconProps: DEFAULT_ICONS_PROPS
};
ProductSuggest.propTypes = {
  logged: _propTypes.default.bool,
  defaultIconProps: _propTypes.default.object,
  button: _propTypes.default.object
};
var _default = ProductSuggest;
exports.default = _default;

//# sourceMappingURL=index.js.map